import axios from 'axios';
import config from '@assets/config.json'; // api 请求json 

const state = {
  albumList: [], // 图集,
}
const mutations = {
  setAlbum(state, data) {
    state.albumList = data;
  },
}
const getters = {
  getAlbum: state => {
    return state.albumList;
  },
}
const actions = {
  changeAlbumByArr({ rootState, commit }, opt) { // 修改素材的图集分组 多项
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/albumPhoto/ChangeAlbumBatch`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  changeAlbum({ rootState, commit }, opt) { // 修改素材的图集分组
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/albumPhoto/ChangeAlbum`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  changeAlbumName({ rootState, commit }, opt) { // 修改素材的图集
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/albumPhoto/ChangeName`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getAlbumByOut({ rootState, commit }, opt) { // 获取未分组图集
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/albumPhoto/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          commit('setAlbum', data.data);
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getAlbumById({ rootState, commit }, id) { // 获取图集
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/album/?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          commit('setAlbum', data.data);
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getAlbum({ rootState, commit }, opt) { // 获取图集
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/album/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          commit('setAlbum', data.data);
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  addAlbum({ rootState }, opt) { // 添加图集
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/album`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delAlbum({ rootState }, id) { // 删除图集
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/album?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  editAlbum({ rootState }, opt) { // 修改图集
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/album`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },

  // 图集里的图片
  getAlbumPhoto({ rootState, commit }, opt) { // 获取图集的图片
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/albumPhoto/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  getAlbumPhotoByAlbumId({ rootState, commit }, opt) { // 获取图集的图片通过id
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/albumPhoto/GetByAlbumId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  addAlbumPhoto({ rootState }, opt) { // 添加图集的图片
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/albumPhoto`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delAlbumPhoto({ rootState }, id) { // 删除图集的图片
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/albumPhoto?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  delBatchAlbumPhoto({ rootState }, opt) { // 批量删除图集的图片
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/albumPhoto/DeleteBatch`, { data: opt, ...rootState.header }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  editAlbumPhoto({ rootState }, opt) { // 修改图集的图片
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/albumPhoto`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 